export function showHideRefundEmail() {
  var show_hide = $('#feature_supports_refund_by_email').prop('checked') ? 'show' : 'hide';
  $('#p_contract_refund_email')[show_hide]();
}
export function listenForSupportRefundEmailOnMidChange() {
  if ($('#feature_supports_refund_by_email').length) {
    showHideRefundEmail();
  }

  $('#feature_supports_refund_by_email').on('change', function () {
    showHideRefundEmail();
  });
}